<template>
  <div class="serve-num">
    <div style="width: 1200px; margin: 0 auto">
      <div style="width: 100%; height: 50px"></div>
      <div
        style="
          line-height: 26px;
          font-size: 26px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #000000;
        "
      >
        服务人数<span
          style="
            line-height: 18px;
            font-size: 18px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
            margin-left: 10px;
          "
          >Customer&nbsp;Statistics</span
        >
      </div>
      <div
        style="width: 54px; height: 2px; background: #3476c1; margin-top: 20px"
      ></div>
      <div
        style="
          width: 1200px;
          margin: 104px auto 0;
          display: flex;
          justify-content: space-between;
        "
      >
        <div
          class="serve-num-i-wrap"
          v-for="(item, index) in list"
          :key="index"
          @mouseover="openFn(index)"
          @mouseleave="closeFn(index)"
        >
          <div class="serve-num-circle">{{ item.num }}</div>
          <div
            class="serve-num-i"
            style="height: 145px; font-family: MicrosoftYaHei"
            ref="liCon"
          >
            <div
              style="
                width: 100%;
                text-align: center;
                height: 21px;
                line-height: 22px;
                font-size: 22px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: #5fc0e4;
                margin-top: 90px;
                margin-bottom: 35px;
              "
              :style="itemIndex === index ? 'color:rgba(15,155,241,1);' : ''"
              v-text="item.name"
            ></div>
            <!-- <div style="width:100%;height:auto;margin-bottom:34px;"> -->
            <div
              :style="
                item.provinces.length > 4
                  ? 'height:120px;overflow-y:auto;width:100%;margin-bottom:34px;'
                  : 'width:100%;height:auto;margin-bottom:34px;'
              "
              v-if="item.provinces"
            >
              <div
                class="serve-num-i-province"
                v-for="(itemSub, index) in item.provinces"
                :key="index"
              >
                {{ itemSub.provinceName }}：{{ itemSub.totalNum }}
              </div>
            </div>

            <!-- <div class="serve-num-i-province">内蒙古：2768</div>
                    <div class="serve-num-i-province">北 京：126</div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="phoneupload">
      <div style="padding-top:17px;text-align: center;width:100%">
        <img class="img1" src="../../static/home/phoneactive.png" alt="">
        <img class="img2" src="../../static/home/phone.png" alt="">
      </div>
      <div class="phonename">
        <p>手机APP下载</p>
      </div>
    </div>
    <div class="uploadImg">
      <div class="sanjiao">&#9660;</div>
      <div style="width:134px">
        <div class="imgwrap">
          <img src="../../static/home/shixuncode.png" alt="">
        </div>
        <p class="imgp" style="text-align: center">实训APP</p>
      </div>
      <div style="width:134px">
        <div class="imgwrap">
          <img src="../../static/home/wangchuangcode.png" alt="">
        </div>
        <p class="imgp" style="text-align: center">网创APP</p>
      </div>
      <div style="width:134px">
        <div class="imgwrap">
          <img src="../../static/home/QRCode.png" alt="">
        </div>
        <p class="imgp" style="text-align: center">慕课APP</p>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "serve-num",
  data() {
    return {
      list: ["总数", "慕课", "测评", "网创", "实训", "就业实训"], //元素列表
      initHeight: 145, //元素初始高度
      sum: 1438923, //总数
      itemIndex: -1,
    };
  },
  methods: {
    openFn(i) {
      // return
      //展开
      this.itemIndex = i;
      const liCon = this.$refs.liCon[i];
      let height = liCon.offsetHeight;
      if (height === this.initHeight) {
        // 展开
        liCon.style.height = "auto";
        height = liCon.offsetHeight;
        liCon.style.height = this.initHeight + "px";
        // eslint-disable-next-line no-unused-vars
        let f = document.body.offsetHeight; // 必加
        if (height != this.initHeight) {
        }
        liCon.style.height = height + "px";
      } else {
        // 收缩
        //     // liCon.style.height = this.liConHeight + 'px'
      }
    },
    closeFn(i) {
      // return
      //收起
      this.itemIndex = -1;
      const liCon = this.$refs.liCon[i];
      let height = liCon.offsetHeight;
      liCon.style.height = this.initHeight + "px";
    },
    refreshDataFn() {
      //总人数
      this.$axios
        .get("/v1/cloud/data/cloud/data")
        .then(({ data }) => {
          if (data) {
            let arr = data;
            let curObj = arr[arr.length - 1]; //当前位置对象
            arr.unshift(curObj);
            arr.splice(arr.length - 1, 1);
            arr.forEach((element) => {
              element.name = element.name.replace("<br/>", "");
              console.log(element);
            });
            this.list = arr;
          }
        })
        .catch((error) => {
          // this.$message.error(error.response.data.message);
        });
    },
  },
  created() {
    //总人数
    this.$axios
      .get("/v1/cloud/data/cloud/data")
      .then(({ data }) => {
        if (data) {
          let arr = data;
          let curObj = arr[arr.length - 1]; //当前位置对象
          arr.unshift(curObj);
          arr.splice(arr.length - 1, 1);
          arr.forEach((element) => {
            element.name = element.name.replace("<br/>", "");
          });
          this.list = arr;
        }
      })
      .catch((error) => {
        this.$message.error(error.response.data.message);
      });
  },
  mounted() {
    //计时器
    this.timer = setInterval(() => {
      this.refreshDataFn();
    }, 300000);
  },
  beforeDestroy() {
    //清除计时器
    clearInterval(this.timer);
  },
};
</script>

<style scoped lang="less">
// 服务人数
.serve-num {
  width: 100%;
  height: 395px;
  background-image: url("../../static/home/homebgi.png");
  background-size: cover;
  position: relative;
  .phoneupload {
    position: absolute;
    width: 100px;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 0px 13px 0px rgba(56, 56, 56, 0.13);
    border-radius: 10px;
    right: 10px;
    top: 51px;
    img {
      width: 23px;
      height: 41px;
      margin: 0 auto;
    }
    .img1 {
      display: block;
    }
    .img2 {
      display: none;
    }
    .phonename {
      padding-top: 11px;
      text-align: center;
      color: #3476C1;
    }
  }
  .phoneupload:hover {
      background: #3476C1;
      .img1 {
        display: none;
      }
      .img2 {
        display: block;
      }
      .phonename {
        color: #FFFFFF;
      }
    }
    .phoneupload:hover ~ .uploadImg {
      opacity: 1;
    }
  .uploadImg {
    opacity: 0;
    width: 458px;
    height: 187px;
    background: #FFFFFF;
    box-shadow: 0px 0px 38px 0px rgba(56, 56, 56, 0.2);
    border-radius: 6px;
    padding: 14px 14px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 6px;
    right: 141px;
    z-index: 999;
    .sanjiao {
      position: absolute;
      right: -9px;
      top: 88px;
      transform: rotate(29deg);
      color: #fff;
    }
    .imgp {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #3476C1;
      line-height: 36px;
    }
    .imgwrap {
      width: 134px;
      height: 134px;
      border: 4px solid #CDE4FE;
      border-radius: 5px;
      box-sizing: border-box;
      img {
        margin: 3px;
        width: 120px;
        height: 120px;
      }
    }
  }
  .serve-num-i-wrap {
    width: 172px;
    height: 145px;
    position: relative;
    .serve-num-circle {
      position: absolute;
      top: -70px;
      left: 26px;
      width: 122px;
      height: 140px;
      text-align: center;
      opacity: 1;
      z-index: 4;
      font-size: 22px;
      line-height: 140px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #fff;
      background-image: url("../../static/home/duobianxing.png");
      background-size: 122px 140px;
    }
    .serve-num-i {
      width: 172px;
      height: 145px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(153, 153, 153, 0.2);

      position: absolute;
      z-index: 3;
      height: 100px;
      overflow: hidden;
      transition: height 0.3s; // 动画效果
    }
    .serve-num-i-province {
      width: 100%;
      padding-left: 40px;
      height: 14px;
      line-height: 14px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #666;
      margin-top: 10px;
    }
    // .serve-num-i-province:last-of-type{margin-bottom:34px; }
  }
}
</style>